var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAquilaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0148 35.7353L36.7337 33.5028L25.3929 0H22.8601L20.2136 7.55783C21.0579 7.74454 21.9103 7.93937 22.7545 8.1342L22.7708 8.07738L27.739 22.9089H17.6564V22.8764L17.5184 22.9089L15.4646 21.1229L11.1377 33.4947L8.90527 35.7272H15.7325L13.4513 33.3892L16.1303 25.2712H29.184L31.9441 33.3973L29.6061 35.7353H39.0148Z",
    fill: "#595A5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75415 10.1635C9.10836 10.6262 11.4788 11.0321 13.8411 11.4624C13.833 11.5435 13.8249 11.6328 13.8087 11.714C11.698 11.5841 9.5792 11.4624 7.46853 11.3325C7.34676 11.4948 7.23311 11.6491 7.11134 11.8114C8.58069 13.1915 10.0094 14.6121 11.5356 15.9191C12.0389 16.3494 12.7858 16.6579 13.4433 16.7066C14.9289 16.8202 16.4308 16.7471 17.9326 16.7471C17.9326 16.8121 17.9326 16.8689 17.9326 16.9257C16.447 17.153 14.9533 17.3803 12.9969 17.6807C14.799 19.2475 16.3009 20.5464 17.7946 21.8452C20.5303 21.2851 23.745 21.626 25.3768 18.8822L22.0971 9.00261C16.9097 7.82551 11.7142 6.67276 6.52684 5.52C4.50547 5.07352 2.46786 4.6595 0.43837 4.22925C0.292247 4.42408 0.146123 4.62703 0 4.82186C1.7616 6.41298 3.49884 8.02034 5.29291 9.57087C5.67446 9.89559 6.24271 10.0661 6.75415 10.1635Z",
    fill: "#BF1F2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAquilaLogo);
export default __webpack_public_path__ + "static/media/aquilaLogo.c2798669cf67ad99d88d48e8c1221178.svg";
export { ForwardRef as ReactComponent };